export enum AddProductStep {
    Product = 'Product',
    Settings = 'Settings',
}
